import { render, staticRenderFns } from "./survey-questions.vue?vue&type=template&id=66c7278e&scoped=true&"
import script from "./survey-questions.vue?vue&type=script&lang=js&"
export * from "./survey-questions.vue?vue&type=script&lang=js&"
import style0 from "./survey-questions.vue?vue&type=style&index=0&id=66c7278e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c7278e",
  null
  
)

component.options.__file = "survey-questions.vue"
export default component.exports